export default "__VITE_ASSET__d2325195__"